import tokiot from './tokiot';
import amap from './amap';
import wechat from './wechat';
import video from "./video"

export default {
    tokiot, amap,wechat,video
};